import type { ApiSendGridInvoicesPayload } from "../../cores/emailMarketing/services/api";

const LS_KEY = "wembii_sendgrid_invoices_v1";

export function readSendGridInvoicesLocalCache(): ApiSendGridInvoicesPayload | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(LS_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as ApiSendGridInvoicesPayload;
    if (!parsed || !Array.isArray(parsed.invoices)) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function writeSendGridInvoicesLocalCache(
  payload: ApiSendGridInvoicesPayload
): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(LS_KEY, JSON.stringify(payload));
  } catch {
    /* quota or private mode */
  }
}
